import Table from 'react-bootstrap/Table';

function Table2() {
  return (
    <Table striped bordered variant="success" >
      <thead>
        <tr>
          
          <th className='text-bold'>Scientific name</th>
          <th className='text-bold'>Common name</th>
          
        </tr>
      </thead>
      <tbody>


        <tr>     
          <td className='font-italic'>Passer domesticus</td>
          <td>House sparrow</td>
        </tr>

        <tr>     
          <td className='font-italic'>Streptopelia decaocto</td>
          <td>Eurasian collared dove</td>
        </tr>

        <tr>     
          <td className='font-italic'>Lonchura punctulata</td>
          <td>Nutmeg manikin</td>
        </tr>

        <tr>     
          <td className='font-italic'> Zenaida asiatica</td>
          <td>White wing dove</td>
        </tr>


        <tr>     
          <td className='font-italic'>Osteopilus septentrionalis</td>
          <td>Cuban tree frog</td>
        </tr>

        <tr>     
          <td className='font-italic'>Pterois volitans</td>
          <td>Lionfish</td>
        </tr>


        <tr>     
          <td className='font-italic'>Helogate parvula,</td>
          <td>Indian mongoose</td>
        </tr>

        <tr>     
          <td className='font-italic'>Rattus rattus</td>
          <td>Black rat</td>
        </tr>


        <tr>     
          <td className='font-italic'>Capra hircus</td>
          <td>Feral goats </td>
        </tr>


        <tr>     
          <td className='font-italic'>Capra hircus</td>
          <td>Feral goats </td>
        </tr>


        <tr>     
          <td className='font-italic'>Achatina fulica</td>
          <td>Giant African snail</td>
        </tr>


        <tr>     
          <td className='font-italic'>Pomacea canaliculata</td>
          <td>Golden apple snail</td>
        </tr>

        <tr>     
          <td className='font-italic'>Zachrysia provisoria</td>
          <td>Cuban garden snail</td>
        </tr>

        <tr>     
          <td className='font-italic'>Maconellicoccus hirsutus</td>
          <td>Pink mealybug</td>
        </tr>

        <tr>     
          <td className='font-italic'>Solenopsis invicta</td>
          <td>Red imported fire ants</td>
        </tr>

        <tr>     
          <td className='font-italic'>Anastrepha oblique</td>
          <td>West Indian fruit fly</td>
        </tr>

        <tr>     
          <td className='font-italic'>Nylanderia fulva</td>
          <td>Hairy crazy ant</td>
        </tr>

        <tr>     
          <td className='font-italic'>Scyphophorus acupunctatus
        </td>
          <td>Agave weevil
        </td>
        </tr>


        <tr>     
          <td className='font-italic'>Paracoccus marginatus</td>
          <td>Papaya mealybug</td>
        </tr>


        <tr>     
          <td className='font-italic'>Varroa destructor</td>
          <td>Varroa mites</td>
        </tr>

        
        <tr>     
          <td className='font-italic'>Raoiella indica</td>
          <td>Red palm mite</td>
        </tr>

        <tr>     
          <td className='font-italic'>Amblyomma variegatum fabricius</td>
          <td>Tropical bont tick</td>
        </tr>

        <tr>     
          <td className='font-italic'>Aleurocanthus woglumi</td>
          <td>Citrus black fly</td>
        </tr>

        <tr>     
          <td className='font-italic'>Pseudacysta perseae</td>
          <td>Avocado lace bug</td>
        </tr>

        <tr>     
          <td className='font-italic'>Gynaikothrips ficorum</td>
          <td>Cuban laurel thrip</td>
        </tr>







      </tbody>
    </Table>
  );
}

export default Table2;